// import Grid from '@material-ui/core/Grid';
import { InputAdornment } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import * as _ from "lodash";
import * as React from "react";

export interface ISearchResult<T> {
  item: T;
  show: boolean;
}

export function searchFilterMeta<T>(
  searchList: T[],
  query: string,
  keys: string[]
): Array<ISearchResult<T>> {
  // Make sure we have text or numbers in our query
  const queries = query.match(/.*\w/g);

  // If we have no queries, return the unsorted list
  if (!queries) {
    return searchList.map((i: T) => ({
      item: i,
      show: true,
    }));
  }

  // Make the queries lower case and remove whitespace
  const queriesLower = query
    .toLowerCase()
    .split(/[, ]+/g)
    .filter((q) => q);

  // Let's do the searching/filtering
  return searchList
    .map((item: T) => {
      // build the search string based on the specified properties
      // https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
      const searchString = keys
        .map((accessor: string) => _.get(item, accessor))
        .join("")
        .toLowerCase();

      // set the hit property to a number based on the number of matches the query had to the searchString
      return {
        hits: queriesLower.reduce(
          (hits, queryLower) =>
            hits + (searchString.indexOf(queryLower) === -1 ? 0 : 1),
          0
        ),
        item,
      };
    })
    .sort((a, b) => {
      // filter out items with a score of 0 and sort the rest
      return b.hits - a.hits;
    })
    .map((entry) => ({
      item: entry.item,
      show: !!entry.hits,
    }));
}

export function searchFilter<T>(
  searchList: T[],
  query: string,
  keys: string[]
): T[] {
  return searchFilterMeta(searchList, query, keys)
    .filter((info) => info.show)
    .map((info) => info.item);
}

interface ISearchBarProps extends React.Props<{}> {
  Adornment?: React.FC;
  onChange: (query: React.ChangeEvent<HTMLInputElement>) => void;
  search: string;
  label?: string;
}

export default class SearchBar extends React.Component<ISearchBarProps, {}> {
  public render() {
    const { Adornment, search, label } = this.props;
    return (
      <TextField
        type="search"
        value={search}
        label={label ? label : "Search"}
        onChange={this.handleChange}
        InputProps={{
          startAdornment: !!Adornment && (
            <InputAdornment position="start">
              <Adornment />
            </InputAdornment>
          ),
        }}
      />
    );
  }

  private handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    this.props.onChange(e);
}



// WEBPACK FOOTER //
// ./src/shared/components/SearchBar.tsx